import { useQuery } from '@tanstack/react-query';
import { queries } from '../../../queries';
import { IGetManualHistoryParams, IGetManualsParams, ILinkedModelsParams } from './types';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../types';
import { handleError } from '../../../../components/ui/err/handleError';

export function useGetManuals(params: IGetManualsParams) {
  return useQuery({
    ...queries.aiAgent.aiAgentManuals(params),
    enabled: !!params.companyId && params.companyId > 0,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}

export function useGetManualHistory(params: IGetManualHistoryParams) {
  return useQuery({
    ...queries.aiAgent.aiAgentManualHistory(params),
    enabled: !!params.companyId && params.companyId > 0 && !!params.fileUploadId && params.fileUploadId > 0,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}

export function useGetAiAgentLearningUsage(params: { companyId: number }) {
  return useQuery({
    ...queries.aiAgent.aiAgentLearningUsage(params),
    enabled: !!params.companyId && params.companyId > 0,
    select: (data) => data.result[0],
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}

export function useGetLinkedModels(params: ILinkedModelsParams) {
  return useQuery({
    ...queries.aiAgent.linkedModels(params),
    enabled: !!params.companyId && params.companyId > 0 && !!params.fileUploadId && params.fileUploadId > 0,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
